import { Mail } from 'lucide-react';
import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

const NotActiveAccount = ({ user, company }) => {

    function capitalizeFirstLetter(string) {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        <div className="fixed w-full h-full top-0 left-0 bg-white flex items-center flex-col justify-center">
            <div className='mb-16'>
                <img className='w-60 h-auto' src={`${process.env.PUBLIC_URL}/assets/notify-cropped-wide.png`} alt="" />
            </div>
            <div className='text-center items-center flex flex-col gap-y-4'>
                <p className='font-extrabold text-zinc-700 text-3xl'>Oops! Can't Access Your Account</p>
                <p className='text-lg w-1/2'>
                    Hello{" "}
                    <span className='font-semibold text-green-700'>
                        {capitalizeFirstLetter(user?.full_name?.split(' ')[0] || user?.username)}
                    </span>!{" "}
                    It looks like your account is <span className='font-semibold text-red-700'>{user.status.split("_").join(" ")}</span>. This usually means it's waiting to be activated by your administrator, or access has been temporarily restricted.
                </p>
                <p className='mt-12 text-lg w-1/2'>Think something's wrong? Get in touch with your company administrator or our support team—we're here to help!</p>
            </div>
            <div className='flex flex-row items-center justify-center align-middle gap-x-2 mt-4 text-green-700 font-semibold'>
                <Mail />
                <a href="mailto:info@notifyapp.com.au">info@notifyapp.com.au</a>
            </div>
        </div>
    );
};

export default NotActiveAccount;
